import "./start-widget.css";
import React, { useState, useEffect, useRef } from "react";
import Widget from "./widget/Widget";
import VendorConfirmation from "../confirmation/VendorConfirmation";
import { Constants } from "../../../_helpers/Constants";

const StartWidget: React.FC = () => {
  const queryString = window.location.href;
  const urlParams = new URLSearchParams(queryString);

  const idParam = urlParams.get("id");
  const reservationParam = urlParams.get("itineraryNumber");
  const customerParam = urlParams.get("customerId");
  const vendorParam = urlParams.get("vendorId");
  const autoScroll = urlParams.get("autoScroll");
  let campaignIdParam = urlParams.get("campaignId");
  const packageParam = urlParams.get("pkg");

  if (campaignIdParam) {
    // set the param in local storage to be reused if lost in traversal
    window.localStorage.setItem("isAdConversion", "true");
  } else {
    campaignIdParam = window.localStorage.getItem("isAdConversion");
  }

  return (
    <div className="start-widget-container">
      {(vendorParam === null || vendorParam === undefined) && (
        <Widget
          startWidgetId={idParam == null ? 1 : +idParam}
          itineraryNumber={reservationParam == null ? undefined : reservationParam}
          customerId={customerParam == null ? undefined : +customerParam}
          autoScroll={autoScroll == null ? true : (autoScroll === "false" ? false : true)}
          vendorGuid={undefined}
          campaignId={campaignIdParam == null ? undefined : campaignIdParam}
          packageParam={packageParam == null ? undefined : packageParam}
        />
      )}

      {(vendorParam !== null && vendorParam !== undefined && reservationParam !== null && reservationParam !== undefined) && (
        <VendorConfirmation
          startWidgetId={idParam == null ? 1 : +idParam}
          itineraryNumber={reservationParam as string}
          vendorGuid={vendorParam}
        />
      )}

      {(vendorParam !== null && vendorParam !== undefined && (reservationParam === null || reservationParam === undefined)) && (
        <Widget
          startWidgetId={idParam == null ? 1 : +idParam}
          itineraryNumber={undefined}
          customerId={undefined}
          autoScroll={autoScroll == null ? true : (autoScroll === "false" ? false : true)}
          vendorGuid={vendorParam}
          campaignId={campaignIdParam == null ? undefined : campaignIdParam}
          packageParam={packageParam == null ? undefined : packageParam}
        />
      )}
    </div>
  )
}

export default StartWidget